import WX_API from '@/utils/wx_api'
import Cookie from '@/utils/cookie'

const storage = {
    get (key) {
        const val = Cookie.getItem(key)
        return val ? JSON.parse(val) : ''
    },
    set (key, data) {
        return Cookie.setItem(key, JSON.stringify(data), {
            sPath: '/'
        })
    },
    remove (key) {
        Cookie.remove(key)
    }
}

const handleHistory = (value, history) => {
    const pastIndex = history.indexOf(value)
    if (pastIndex > -1) {
        history.splice(pastIndex, 1)
    }
    history.unshift(value)
    if (history.length > 10) {
        history.pop()
    }
    return history
}

const addHistory = (key, value) => {
    if (value) {
        let history = WX_API.getStorageSync(key) || []
        console.log(history)
        history = handleHistory(value, history)
        WX_API.setStorageSync(key, history)
        return history
    }
}

const LocalData = {
    token () {
        return storage.get('token')
    },
    search: {
        get () {
            return WX_API.getStorageSync('search_history') || []
        },
        add (value) {
            return addHistory('search_history', value)
        },
        remove () {
            window.localStorage.removeItem('search_history')
        }
    },
    filter_search: {
        get (type) {
            const search = WX_API.getStorageSync('filter_search')
            return search && search[type] ? search[type] : []
        },
        add (type, value) {
            let search = WX_API.getStorageSync('filter_search') || {}
            search[type] = handleHistory(value, search[type] || [])
            WX_API.setStorageSync('filter_search', search)
            return search[type]
        },
        remove (type) {
            const search = storage.get('filter_search') || {}
            delete search[type]
            WX_API.setStorageSync('filter_search', search)
        }
    },
    result_search: {
        get () {
            return WX_API.getStorageSync('search_result_history')
        },
        add (value) {
            return addHistory('search_result_history', value)
        },
        remove () {
            window.localStorage.removeItem('search_result_history')
        }
    },
    review_search: {
        get () {
            return WX_API.getStorageSync('search_review_history')
        },
        add (value) {
            console.error(value)
            return addHistory('search_review_history', value)
        },
        remove () {
            window.localStorage.removeItem('search_review_history')
        }
    },
    second_hand_search: {
        key: 'second_hand_search_history',
        get () {
            return WX_API.getStorageSync(this.key)
        },
        add (value) {
            return addHistory(this.key, value)
        },
        remove () {
            window.localStorage.removeItem(this.key)
        }
    },
    user: {
        DONE: false,
        set (user) {
            if (!this.DONE) {
                this.DONE = true
                storage.set('user', user)
            }
        },
        get () {
            return new Promise((res) => {
                res(storage.get('user'))
            })
        }
    }
}

export default LocalData
